import UECard from "../UECard";
import '../../styles/ue_radio.css';
import '../../styles/ue_style.css';
import '../../styles/ue_checkbox.css';
import '../../styles/ue_card.css';
import { Col, Overlay, OverlayTrigger, Row, Tooltip } from "react-bootstrap";
import { useContext, useEffect, useRef, useState } from "react";
import ModalPopup from "../ModalPopup";
import useQuery from "../../hooks/useQuery";
import { readCurrentState, sendCurrentState, StepContext } from "../StepContext";
import {getListaOfferte} from "../steps_pages/Step5";
import useIPInfo from "../../hooks/useIPInfo";
import { useClientInfo } from "../../hooks/useClientInfo";



function validaTelefono(t) {
    //const re = /^((00|\+)39[\. ]??)??3\d{2}[\. ]??\d{6,7}$/;
    const re = /^3[0-9]{2}[0-9]{6,7}$/;
    return re.test(t);
}
export function validateEmail(email) {
    //const re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    //const re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\")){3,}@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\]){3,}|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    const re = /^[\w._-]{3,}@[\w.-]{3,}\.[a-zA-Z]{2,4}$/;
    return re.test(email);
}


export function validaCodiceFiscale(cf) {
    var validi, i, s, set1, set2, setpari, setdisp;
    if (cf == '') return '';
    cf = cf.toUpperCase();
    if (cf.length != 16)
        return false;
    validi = "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
    for (i = 0; i < 16; i++) {
        if (validi.indexOf(cf.charAt(i)) == -1)
            return false;
    }
    set1 = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ";
    set2 = "ABCDEFGHIJABCDEFGHIJKLMNOPQRSTUVWXYZ";
    setpari = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
    setdisp = "BAKPLCQDREVOSFTGUHMINJWZYX";
    s = 0;
    for (i = 1; i <= 13; i += 2)
        s += setpari.indexOf(set2.charAt(set1.indexOf(cf.charAt(i))));
    for (i = 0; i <= 14; i += 2)
        s += setdisp.indexOf(set2.charAt(set1.indexOf(cf.charAt(i))));
    if (s % 26 != cf.charCodeAt(15) - 'A'.charCodeAt(0))
        return false;
    return true;
}

var msgText = '';
var msgTitle = '';
//flag per la lettura dei parametri url solo per il primo rendering
var readURLParams = true;



function Step1() {
    let query = useQuery();
    let IPInfo = useIPInfo();
    let clienInfo = useClientInfo();
    const { step, setStep } = useContext(StepContext);

    const [personaFisica, setPersonaFisica] = useState(true);
    const [personaGiuridica, setPersonaGiuridica] = useState(false);
    const [ch_privacy, setPrivacy] = useState(false);
    const [ch_privacyMarketing, setPrivacyMarketing] = useState(false);
    const [ch_privacyTerzi, setPrivacyTerzi] = useState(false);
    const [ch_privacyCallMe, setPrivacyCallMe] = useState(true);

    const [nome, setNome] = useState('');
    const [cognome, setCognome] = useState('');
    const [ragsoc, setRagsoc] = useState('');
    const [codSDI, setCodSDI] = useState('');
    const [piva, setPiva] = useState('');
    const [cofi, setCofi] = useState('');
    const [mobile, setMobile] = useState('');
    const [mail, setMail] = useState('');
    const [mail2, setMail2] = useState('');
    const [pec,setPEC] = useState('');
    const [rif,setRif] = useState(''); //Riferimento esterno

    const [modalShow, setModalShow] = useState(false);

    const [showTargetPrivacy, setShowTargetPrivacy] = useState(false);
    const targetPrivacy = useRef(null);



    function ch_privacyCallMeChange() {
        setPrivacyCallMe(!ch_privacyCallMe);
    }
    function ch_privacyChange() {
        setPrivacy(!ch_privacy);
        setShowTargetPrivacy(ch_privacy);
    }
    function ch_privacyTerziChange() {
        setPrivacyTerzi(!ch_privacyTerzi);
    }
    function ch_privacyMarketingChange() {
        setPrivacyMarketing(!ch_privacyMarketing);
    }

    function pfOnChange(e) {
        setPersonaFisica(true);
        setPersonaGiuridica(false);
    }
    function pgOnChange(e) {
        setPersonaFisica(false);
        setPersonaGiuridica(true);
    }

    function MostraDatiGet() {
        //console.log('MostraDatiGet');

        if (query.has("nome"))
            setNome(query.get("nome"));
        if (query.has("cognome"))
            setCognome(query.get("cognome"));
        if (query.has("ragsoc"))
            setRagsoc(query.get("ragsoc"));
        if (query.has("cofi"))
            setCofi(query.get("cofi"));
        if (query.has("piva"))
            setPiva(query.get("piva"));
        if (query.has("mobile"))
            setMobile(query.get("mobile"));
        if (query.has("mail"))
            setMail(query.get("mail"));
        if (query.has("pf"))
            if (query.get("pf") == "1") {
                setPersonaFisica(true);
                setPersonaGiuridica(false);
            } else {
                setPersonaFisica(false);
                setPersonaGiuridica(true);
            }

        if (query.has("rif"))
            setRif(query.get("rif"))
    }

    function MostraDatiLocalStorage() {
        setPersonaFisica(readCurrentState("pf"));
        setPersonaGiuridica(!readCurrentState("pf"));

        setNome(readCurrentState("nome"));
        setCognome(readCurrentState("cognome"));
        setRagsoc(readCurrentState("ragsoc"));
        setCofi(readCurrentState("cofi"));
        setPiva(readCurrentState("piva"));
        setMobile(readCurrentState("mobile"));
        setMail(readCurrentState("mail"));
        setMail2(readCurrentState("mail"));
        setPEC(readCurrentState("pec"));

        setCodSDI(readCurrentState("cod_sdi"));

        setPersonaFisica(readCurrentState("pf"));
        setPersonaGiuridica(!readCurrentState("pf"));

        setPrivacy(readCurrentState("privacy"));
        setPrivacyCallMe(readCurrentState("privacyCallMe"));
        setPrivacyMarketing(readCurrentState("privacyMarketing"));
        setPrivacyTerzi(readCurrentState("privacyTerzi"));
    }


    useEffect(() => {
        if (readURLParams) {
            setPersonaFisica(true);

            MostraDatiGet();
            readURLParams = false;
        } else {
            MostraDatiLocalStorage();
        }     
        
        getListaOfferte(query);

        //IPInfo.getIPinformation();
    }, []);



    function Validation() {
        if (personaFisica) {
            if (nome.trim().length < 2) {
                msgText = 'Inserire un nome valido';
                msgTitle = 'Informazioni non valide o mancanti';
                setModalShow(true);
                return false;
            }
            if (cognome.trim().length < 2) {
                msgText = 'Inserire un cognome valido';
                msgTitle = 'Informazioni non valide o mancanti';
                setModalShow(true);
                return false;
            }
            if (cofi.trim().length != 16) {
                msgText = 'Inserire un codice fiscale valido';
                msgTitle = 'Informazioni non valide o mancanti';
                setModalShow(true);
                return false;
            }
            if (!validaCodiceFiscale(cofi.trim())) {
                msgText = 'Il codice fiscale inserito non è valido, verifica che non ci siano errori';
                msgTitle = 'Informazioni non valide o mancanti';
                setModalShow(true);
                return false;
            }

        } else {
            if (ragsoc.trim().length <= 0) {
                msgText = 'Inserire una ragione sociale valida';
                msgTitle = 'Informazioni non valide o mancanti';
                setModalShow(true);
                return false;
            }
            if (codSDI.trim().length <= 0) {
                msgText = 'Inserire il tuo codice univoco o la PEC per ricevere le fatture elettroniche. Inserisci 0000000 se non hai a portata questa informazione, inserisci il codice XXXXXXX se la tua società ha sede legale estera.';
                msgTitle = 'Informazioni fatturazion non valide o mancanti';
                setModalShow(true);
                return false;
            }
            if (!codSDI.trim().includes('@')) {
                if((codSDI.trim().length<6)||codSDI.trim().length>7){
                    msgText = 'Il codice destinatario è un codice composto da numeri e lettere di 7 caratteri, 6 per la pubblica amministrazione.';
                    msgTitle = 'Informazioni fatturazion non valide o mancanti';
                    setModalShow(true);
                    return false;
                }
            }else{
                if (!validateEmail(codSDI)) {
                    msgText = 'Inserire un indirizzo PEC per la fatturazione elettronica valido.';
                    msgTitle = 'Informazioni non valide o mancanti';
                    setModalShow(true);
                    return false;
                }
            }            
            if ((piva.trim().length != 8) && (piva.trim().length != 11)) {
                msgText = 'Inserire una partita iva valida';
                msgTitle = 'Informazioni non valide o mancanti';
                setModalShow(true);
                return false;
            }
            if ((piva.trim().length != 8) && (piva.trim().length != 11) && (cofi.trim().length != 16)) {
                msgText = 'Inserire un codice fiscale dell\'azienda valido';
                msgTitle = 'Informazioni non valide o mancanti';
                setModalShow(true);
                return false;
            }
            if (!validateEmail(pec)) {
                console.log(pec);
                msgText = 'Inserire un indirizzo PEC di contatto valido.';
                msgTitle = 'Informazioni non valide o mancanti';
                setModalShow(true);
                return false;
            }
        }
        if (!validaTelefono(mobile)) {
            msgText = 'Numero di telefono mobile non valido. Inserisci un numero di telefono cellulare Italiano senza prefisso internazionale (+39).';
            msgTitle = 'Informazioni non valide o mancanti';
            setModalShow(true);
            return false;
        }
        if (!validateEmail(mail)) {
            msgText = 'Inserire un indirizzo e-mail valido.';
            msgTitle = 'Informazioni non valide o mancanti';
            setModalShow(true);
            return false;
        }
        if (process.env.NODE_ENV != 'development') {
            if ((mail != mail2)) {
                msgText = "La mail di conferma non coincide con quella indicata";
                msgTitle = 'Informazioni non valide o mancanti';
                setModalShow(true);
                return false;
            }
        }
        if (!ch_privacy) {
            msgText = 'Per procedere devi autorizzare il trattamento dei dati ai sensi del Regolamento (UE) 2016/679 (obbligatorio).';
            msgTitle = 'INFORMATIVA SULLA TUTELA DEI DATI PERSONALI';
            setShowTargetPrivacy(true);
            setModalShow(true);

            return false;
        }


        //Imposto id agenzia e agente
        //Se esisto come parametri uso quelli da get
        //altrimenti uso il default
        let aga = 29;
        let age = 102

        if (query.has("aga"))
            aga = query.get("aga");
        if (query.has("age"))
            age = query.get("age");
        

        
        let conx = {
            step: step,
            pf: personaFisica,
            nome: nome.trim(),
            cognome: cognome.trim(),
            ragsoc: ragsoc.trim(),
            cofi: cofi.trim(),
            piva: piva.trim(),
            mobile: mobile.trim(),
            mail: mail.trim(),
            pec: pec.trim(),
            privacy: ch_privacy,
            privacyCallMe: ch_privacyCallMe,
            privacyMarketing: ch_privacyMarketing,
            privacyTerzi: ch_privacyTerzi,
            cod_sdi:codSDI,
            id_agenzia: aga,
            id_agente: age,
            IPInformation: IPInfo.IPInfoObject,
            clienInfo:clienInfo.getClientInfo(),
            riferimento: rif,
        };


        StepContext.contratto = { ...StepContext.contratto, ...conx };
        sendCurrentState();
        return true;
    }



    function PersonaFisica() {
        return <>
            <Row>
                <Col>
                    <label htmlFor="nome">
                        Nome*<br />
                        <input type="text" className="ue ue-text" id="nome" placeholder="Inserisci il tuo nome" maxLength="34" value={nome} onChange={(e) => { setNome(e.target.value.toUpperCase()) }} />
                    </label>
                </Col>
                <Col>
                    <label htmlFor="cognome">
                        Cognome*<br />
                        <input type="text" className="ue ue-text" id="cognome" placeholder="Inserisci il tuo cognome" maxLength="35" value={cognome} onChange={(e) => { setCognome(e.target.value.toUpperCase()) }} />
                    </label><br />
                </Col>
            </Row>
            <Row>
                <label htmlFor="cofi">
                            Codice Fiscale*<br />
                            <input type="text" className="ue ue-text" id="cofi" placeholder="Inserisci il codice fiscale" maxLength="16" value={cofi} onChange={(e) => { setCofi(e.target.value.toUpperCase()) }} />
                </label>
            </Row>
        </>
    }
    function PersonaGiuridica() {
        return <>
            <Row >
            <Col>
                    <label htmlFor="ragsoc" >
                        Ragione Sociale*<br />
                        <input type="text" className="ue ue-text" id="ragsoc" placeholder="Inserisci la ragione sociale" maxLength="70" value={ragsoc} onChange={(e) => { setRagsoc(e.target.value.toUpperCase()) }} />
                    </label>
                </Col>  
                <Col>
                    <label htmlFor="sdi" >
                        Codice SDI/PEC <small>per fatturazione elettronica</small> *<br />
                        <input type="text" className="ue ue-text" id="sdi" placeholder="Inserisci il codice destinatario o la pec" maxLength="30" value={codSDI} onChange={(e) => { setCodSDI(e.target.value.toUpperCase()) }} />
                    </label>
                </Col>                
            </Row>
            <Row>
                <Col>
                    <label htmlFor="piva" >
                        Partita IVA*<br />
                        <input type="text" className="ue ue-text" id="piva" placeholder="Inserisci la tua partita IVA" maxLength="13" value={piva} onChange={(e) => { setPiva(e.target.value.toUpperCase()) }} />
                    </label>
                </Col>
                <Col>
                <label htmlFor="cofi">
                            Codice Fiscale*<br />
                            <input type="text" className="ue ue-text" id="cofi" placeholder="Inserisci il codice fiscale" maxLength="16" value={cofi} onChange={(e) => { setCofi(e.target.value.toUpperCase()) }} />
                </label>
                </Col>
            </Row> 
            <Row>
                <p style={{"fontSize":"15px","marginBottom":"-10px"}}><i>Persona autorizzata alla firma del contratto:</i></p>
                <Col>
                    <label htmlFor="nome">
                        Nome*<br />
                        <input type="text" className="ue ue-text" id="nome" placeholder="Inserisci il nome" maxLength="34" value={nome} onChange={(e) => { setNome(e.target.value.toUpperCase()) }} />
                    </label>
                </Col>
                <Col>
                    <label htmlFor="cognome">
                        Cognome*<br />
                        <input type="text" className="ue ue-text" id="cognome" placeholder="Inserisci il cognome" maxLength="35" value={cognome} onChange={(e) => { setCognome(e.target.value.toUpperCase()) }} />
                    </label><br />
                </Col>
            </Row>   
            <Row>
                <Col>
                <label htmlFor="mail">
                            Indirizzo PEC*<br />
                            <input type="mail" className="ue ue-text" id="pec" placeholder="Inserisci l'indirizzo PEC" maxLength="255" value={pec} onChange={(e) => { setPEC(e.target.value.toUpperCase()) }} onCopy={(e)=>{e.preventDefault();}} onPaste={(e)=>{e.preventDefault();}} />
                        </label>
                </Col>
            </Row>
     
        </>
    }
    function RenderTipoPersona() {
        if (personaFisica) {
            return PersonaFisica();
        } else {
            return PersonaGiuridica();
        }
    }

    const handleMobileChange = (e) => {
        let m = e.target.value;
        //console.log(m.startsWith('+39'));
        if ((m.startsWith('+39')) && (m.trim().length > 10)) {
            m = m.replace('+39', '');
        }
        if ((m.startsWith('39')) && (m.trim().length > 10)) {
            m = m.replace('39', '');
        }
        setMobile(m);
    };

    function tipoPersonaDisabled() {
        return (query.has("pf"));
    }

    function tipoPersonaTooltipText() {
        if (query.has("pf")) {
            if (query.get("pf") == 1) {
                return "Questa offerta è destinata alle persone con codice fiscale per l'attivazione di contratti domestici"
            } else {
                return "Questa offerta è destinata alle aziende e società con partita iva per l'attivazione di contratti d tipo 'Altri Usi'"
            }
        }

        return '';
    }

    return (

        <UECard BackButton={false} NextButton={true} className="S1Div" style={{ marginLeft: "250px", width: "100%", textAlign: "center", marginTop: "50px" }} onValidate={Validation}>
            <h2 style={{ color: "green" }}><b>Benvenuto nel Mondo di Umbria Energy!</b><br /> In pochi passi puoi affidarci le tue forniture per metterle in buone mani</h2>
            <br />
            <h2>Scegli che tipo di cliente sei</h2>



            <Row style={{ width: "40%", marginLeft: "30%", marginTop: "10px" }}>
                <Col>
                    <OverlayTrigger overlay={tipoPersonaDisabled() ? <Tooltip id="tooltip-disabled1">{tipoPersonaTooltipText()}</Tooltip> : <Tooltip style={{ visibility: "hidden" }} />}>
                        <span className="d-inline-block">
                            <label className="ue-radio ue-radio-radio">
                                Persona Fisica
                                <input type="radio" name="tipo_soggetto" id="p_fisica" checked={personaFisica} onChange={pfOnChange} disabled={tipoPersonaDisabled()} />
                                <div className="ue-radio_indicator"></div>
                            </label>
                        </span>
                    </OverlayTrigger>
                </Col>
                <Col>
                    <OverlayTrigger overlay={tipoPersonaDisabled() ? <Tooltip id="tooltip-disabled1">{tipoPersonaTooltipText()}</Tooltip> : <Tooltip style={{ visibility: "hidden" }} />}>
                        <span className="d-inline-block">
                            <label className="ue-radio ue-radio-radio">
                                Persona Giuridica / Azienda
                                <input type="radio" name="tipo_soggetto" id="p_giuridica" checked={personaGiuridica} onChange={pgOnChange} disabled={tipoPersonaDisabled()} />
                                <div className="ue-radio_indicator"></div>
                            </label>
                        </span>
                    </OverlayTrigger>
                </Col>
            </Row>

            <hr />
            <div style={{ width: "70%", margin: "0 auto" }}>
                {RenderTipoPersona()}

               {/* <Row >
                    <Col>
                        <label htmlFor="cofi">
                            Codice Fiscale*<br />
                            <input type="text" className="ue ue-text" id="cofi" placeholder="Inserisci il codice fiscale" maxLength="16" value={cofi} onChange={(e) => { setCofi(e.target.value.toUpperCase()) }} />
                        </label>
                    </Col>
                     <Col>
                        <label htmlFor="mail">
                            Indirizzo E-Mail*<br />
                            <input type="mail" className="ue ue-text" id="mail" placeholder="Inserisci la tua e-mail" maxLength="255" value={mail} onChange={(e) => { setMail(e.target.value.toUpperCase()) }} />
                        </label>
                    </Col>
                    
                </Row>*/}

                <Row >
                    <Col>
                        <label htmlFor="mail">
                            Indirizzo E-Mail*<br />
                            <input type="mail" className="ue ue-text" id="mail" placeholder={`Inserisci indirizzo E-Mail`} maxLength="255" value={mail} onChange={(e) => { setMail(e.target.value.toUpperCase()) }} onCopy={(e)=>{e.preventDefault();}} onPaste={(e)=>{e.preventDefault();}} />
                        </label>
                    </Col>
                    <Col>
                        <label htmlFor="mail2">
                            Conferma Indirizzo E-Mail*<br />
                            <input type="mail" className="ue ue-text" id="mail2" placeholder={`Conferma la tua E-Mail`} maxLength="255" value={mail2} onChange={(e) => { setMail2(e.target.value.toUpperCase()) }} onPaste={(e)=>{e.preventDefault();}}/>
                        </label>
                    </Col>

                </Row>

                <Row>

                    <Col>
                        <label htmlFor="mobile">
                            Recapito telefonico* <br /><small>(Numero mobile <u>senza prefisso internazionale</u> dove si riceverà il codice per la conferma
                                dell'attivazione)</small><br />
                            <input type="phone" className="ue ue-text" id="mobile" placeholder="Inserisci il tuo numero di telefono"
                                maxLength="15" value={mobile} onChange={handleMobileChange} />
                        </label>
                    </Col>

                </Row>
                <div style={{ width: "100%", textAlign: "center", marginTop: "50px" }}>
                    <p>Il richiedente è l'intestatario del contratto</p>
                </div>

                <div>
                    <label className="ue-check ue-check-checkbox privacy">
                        Voglio essere ricontattato se non riesco a portare a termine la sottoscrizione del contratto.
                        <input id="ch_privacyCallMe" type="checkbox" checked={ch_privacyCallMe} onChange={ch_privacyCallMeChange} />
                        <div className="ue-check_indicator"></div>
                    </label>

                    <Overlay target={targetPrivacy.current} show={showTargetPrivacy} placement="left">
                        {(props) => (
                            <Tooltip id="overlay-example" {...props}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-arrow-right-square-fill" viewBox="0 0 16 16" style={{ marginTop: "-4px" }}>
                                    <path d="M0 14a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2a2 2 0 0 0-2 2v12zm4.5-6.5h5.793L8.146 5.354a.5.5 0 1 1 .708-.708l3 3a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708-.708L10.293 8.5H4.5a.5.5 0 0 1 0-1z" />
                                </svg>
                            </Tooltip>
                        )}
                    </Overlay>
                    <label ref={targetPrivacy} className="ue-check ue-check-checkbox privacy">
                        Autorizzo al trattamento dei miei dati ai sensi del Regolamento (UE) 2016/679*.
                        <input id="ch_privacy" type="checkbox" checked={ch_privacy} onChange={ch_privacyChange} />
                        <div className="ue-check_indicator"></div>
                    </label>

                    <label className="ue-check ue-check-checkbox privacy">
                        Autorizzo al trattamento dei miei dati con finalità di marketing.
                        <input id="ch_privacyMarketing" type="checkbox" checked={ch_privacyMarketing} onChange={ch_privacyMarketingChange} />
                        <div className="ue-check_indicator"></div>
                    </label>
                    <label className="ue-check ue-check-checkbox privacy">
                        Autorizzo alla comunicazione dei miei dati a terzi.
                        <input id="ch_privacyTerzi" type="checkbox" checked={ch_privacyTerzi} onChange={ch_privacyTerziChange} />
                        <div className="ue-check_indicator"></div>
                    </label>
                    <br />
                    <a href="https://www.umbriaenergy.it/privacy" target="_blank">Leggi l'informativa sulla privacy</a>
                    <br /> <br />
                    <small><b><i>* campi obbligatori</i></b></small>
                </div>
            </div>
            <ModalPopup title={msgTitle} message={msgText} show={modalShow} onHide={() => setModalShow(false)} />
        </UECard>

    );

}

export default Step1;